import React from "react";
import { CircularProgress } from "@mui/material";
import { useTranslation } from "react-i18next";
import { colors } from "../../../theme/colors";
import { usePreventNavigation } from "../../../hooks/usePreventNavigation";
import {
  ContentContainer,
  Title,
  Description,
  SpinnerContainer,
} from "./GeneratingPlanModal.styled";

const GeneratingPlanModalContent: React.FC = () => {
  const { t } = useTranslation();

  // Prevent browser back button while generating
  usePreventNavigation(true);

  return (
    <ContentContainer>
      <Title>{t("generatingPlan.title")}</Title>
      <Description>
        {t("generatingPlan.pleaseWait")}
        <br />
        {t("generatingPlan.generating")}
      </Description>
      <SpinnerContainer>
        <CircularProgress
          size={40}
          sx={{
            color: colors.amber.main,
          }}
        />
      </SpinnerContainer>
    </ContentContainer>
  );
};

export default GeneratingPlanModalContent;
